module.exports = __webpack_public_path__ + "static/media/servImg2.9f5477ea.svg";